import { useTranslation } from "react-i18next";

export const useGenerateNecessaryCookiesList = () => {
	const { t } = useTranslation();

	const cookies: { [key: string]: string }[] = [];
	cookies.push({
		name: "cc_cookie",
		domain: location.hostname,
		expiration: "182 " + t("COOKIE.TABLE_BODY.EXPIRATION"),
		desc: t(
			"COOKIE.PREFERENCES.NECESSARY_COOKIES.TABLE_BODY_CC.DESCRIPTION"
		),
	});
	cookies.push({
		name: "lng",
		domain: location.hostname,
		expiration: "365 " + t("COOKIE.TABLE_BODY.EXPIRATION"),
		desc: t(
			"COOKIE.PREFERENCES.NECESSARY_COOKIES.TABLE_BODY_LNG.DESCRIPTION"
		),
	});

	return cookies;
};
